import React, { useEffect } from 'react'
import NavigationBar from '../components/NavigationBar'
import LandingFooter from '../components/LandingFooter'
import { MDBAccordion, MDBAccordionItem, MDBBreadcrumb, MDBBreadcrumbItem, MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit'
import { Link } from 'react-router-dom'
import { Bell, checkediconblack, MembermanagementImage, PilatesHome, PilatesStudio } from '../assets/images/images'
import MemberManagementData from '../data/MemberManagementData'
import { mmfaqs } from '../data/constants'
import ContactUs from '../components/ContactUs'
import RelatedProducts from '../components/RelatedProducts'
import { useNavigate } from 'react-router';

const MemberManagementLanding = () => {
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleDemoClick = () => {
        navigate('/bookademo');
    };
    return (
        <>
            <NavigationBar classText="blue-logo" from='products' />
            <div className="lp">
                <div className="lp_revenue section-white pt-5">
                    <MDBContainer>
                        <MDBBreadcrumb>
                            <MDBBreadcrumbItem>
                                <Link href='#'>Easymembr</Link>
                            </MDBBreadcrumbItem>
                            <MDBBreadcrumbItem>
                                <Link href='#'>Products</Link>
                            </MDBBreadcrumbItem>
                            <MDBBreadcrumbItem active>Member Management</MDBBreadcrumbItem>
                        </MDBBreadcrumb>


                        <MDBRow className='align-items-center pt-5'>
                            <MDBCol sm={12} md={5} lg={5} xl={5}>
                                <h1 class="mm-main-heading text-dark">Member Management</h1>

                                <p className="pt-3 text-description">
                                    Effortless Member Tracking & Engagement
                                </p>

                                <div className='my-4'>
                                    <MDBListGroup>
                                        <MDBListGroupItem noBorders className='lp_custom-list'>
                                            <img
                                                src={checkediconblack}
                                                className='mr-3'
                                                alt=""
                                            />
                                            Simplify member sign-ups with a user-friendly interface.
                                        </MDBListGroupItem>
                                        <MDBListGroupItem noBorders className='lp_custom-list'>
                                            <img
                                                src={checkediconblack}
                                                className='mr-3'
                                                alt=""
                                            />
                                            Manage all member details from a centralized dashboard.

                                        </MDBListGroupItem>
                                        <MDBListGroupItem noBorders className='lp_custom-list'>
                                            <img
                                                src={checkediconblack}
                                                className='mr-3'
                                                alt=""
                                            />
                                            Access contact information, billing history, and membership plans in one place.
                                        </MDBListGroupItem>
                                        <MDBListGroupItem noBorders className='lp_custom-list'>
                                            <img
                                                src={checkediconblack}
                                                className='mr-3'
                                                alt=""
                                            />
                                            Offer flexible membership options to match different schedules and preferences.
                                        </MDBListGroupItem>

                                    </MDBListGroup>
                                </div>
                            </MDBCol>
                            <MDBCol sm={12} md={6} lg={6} xl={6}>.
                                <img src={MembermanagementImage} alt="" width={500} />
                            </MDBCol>
                        </MDBRow>

                        <hr className='pb-5 mt-5' />
                        <h2 style={{ fontSize: "24px" }} className='text-dark'>
                            Exciting Features for Membership Management
                        </h2>

                        <p>Streamline sign-ups and manage all member data from a centralized dashboard. Access contact info, billing history, and membership plans in one place, and offer flexible membership options tailored to individual schedules and preferences—all designed to improve organization, boost engagement, and enhance the member experience.
                        </p>
                        <MDBRow>
                            {MemberManagementData.map((feature, index) => (
                                <MDBCol sm={12} md={4} lg={4} className='mb-3' key={index} style={{ marginTop: '20px' }}>
                                    <div className='lp_card'>
                                        <MDBCard className='shadow-0'>
                                            <MDBCardBody className='lp_header'>
                                                <img src={feature.icon} alt="" />
                                                <MDBCardTitle className='my-3 text-dark'>{feature.title}</MDBCardTitle>
                                                <div className='lp_small'>{feature.description}</div>
                                            </MDBCardBody>
                                        </MDBCard>
                                    </div>
                                </MDBCol>
                            ))}
                        </MDBRow>

                        {/* <h2 style={{ fontSize: "24px" }} className='text-dark pt-4'>
                            Customize Your Membership Management with EasyMembr
                        </h2>
                        <p>
                            EasyMembr empowers your fitness business with customizable membership features tailored to your members' unique needs. No matter the size of your gym, our platform scales effortlessly to support your growth. Now that’s exciting!

                        </p>


                        <MDBTable bordered>
                            <MDBTableHead>
                                <tr>
                                    <th scope='col'>Feature</th>
                                    <th scope='col'>Functionality</th>
                                </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                                <tr>
                                    <th scope='row'>Pause Option</th>
                                    <td>Pause Membership is for 15 days if they are out of town or on vacation.</td>
                                </tr>
                                <tr>
                                    <th scope='row'>Hold Membership</th>
                                    <td>Accommodate members facing unpredictable situations by putting their Membership on hold.</td>
                                </tr>
                                <tr>
                                    <th scope='row'>Upgrade Plans</th>
                                    <td>Members can upgrade to extended plans, such as a one-year or three-year membership.</td>
                                </tr>
                                <tr>
                                    <th scope='row'>Refunds and Cancellations</th>
                                    <td>Easily manage refunds and cancellations. Suspensions Block a user if necessary.</td>
                                </tr>
                            </MDBTableBody>
                        </MDBTable> */}

                        <div class="row align-items-center cta-v5 mt-5">
                            <div class="col-md-1">
                                <img src={Bell} alt="Note" class="bell-icon" />
                            </div>
                            <div class="col-md-8">
                                <p>
                                    Discover how our advanced membership management system can streamline your studio operations. Start your free trial now and see the difference!
                                </p>
                            </div>
                            <div class="col-md-3">
                                <a href="#!" class="cta-button" onClick={handleDemoClick}>
                                    Schedule a FREE DEMO!</a>
                            </div>
                        </div>
                        <br />
                        <br />
                        <h2 style={{ fontSize: "24px" }} className='text-dark pt-4'>
                            Explore our FAQ section for details
                        </h2>
                        <p>
                            Software questions, answered
                        </p>


                        <MDBAccordion initialActive={1} borderless>
                            {mmfaqs.map((faq) => (
                                <MDBAccordionItem
                                    key={faq.id}
                                    collapseId={faq.id}
                                    headerTitle={faq.title}
                                >
                                    {faq.content.split('\n').map((line, index) => (
                                        <p key={index} style={{ marginBottom: '0.5rem' }}>{line}</p>
                                    ))}
                                </MDBAccordionItem>
                            ))}
                        </MDBAccordion>


                    </MDBContainer>
                </div>


                <div className="section-grey">
                    <ContactUs />
                </div>



            </div>
            <LandingFooter />
        </>
    )
}

export default MemberManagementLanding
